import createVueComponent from '../createVueComponent';
var Terminal = createVueComponent('TerminalIcon', [['polyline', {
  points: '4 17 10 11 4 5',
  key: 'akl6gq'
}], ['line', {
  x1: '12',
  y1: '19',
  x2: '20',
  y2: '19',
  key: 'fyyrwq'
}]]);
export default Terminal;